import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import useIsMobile from '../../Hooks/useIsMobile';

const MobileGrowthRedirect = ({ defaultTab, desktopElement }) => {
    const isMobile = useIsMobile();
    const location = useLocation();

    if (!isMobile) {
        return desktopElement;
    }

    const searchParams = new URLSearchParams(location.search);

    // Special Case: Lost Customer Report on /connections should NOT redirect to Growth
    const isLostCustomerReport = searchParams.has("na") || searchParams.has("NA");
    if (isLostCustomerReport && defaultTab === 'contacts') {
        return desktopElement;
    }

    let targetTab = defaultTab;
    const tid = searchParams.get('tid') || searchParams.get('tID');
    if (tid) {
        if (Number(tid) === 2) {
            targetTab = 'sales';
        } else if (Number(tid) === 1) {
            targetTab = 'inquiries';
        }
    }

    searchParams.set('tab', targetTab);

    return <Navigate to={`/growth?${searchParams.toString()}`} replace />;
};

export default MobileGrowthRedirect;
